import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  IonicModule,
  LoadingController,
  ModalController,
  Platform,
  ToastController
} from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { BrukerService } from '../../services/bruker/bruker.service';
import {
  BrukerkundeResponse,
  KeycloakUserInfo,
  Kundenumre
} from '../../services/bruker/bruker.types';
import { DataService } from '../../services/datatransfer/DataService';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-kundetilgang-modal',
  templateUrl: './kundetilgang-modal.page.html',
  styleUrls: ['./kundetilgang-modal.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule]
})
export class KundetilgangModal implements OnInit {
  brukerkundeResponse: Kundenumre[];
  inUse: Kundenumre;
  tildelte: Kundenumre[];
  kundeIdFromKC: string;

  shareGroup: FormGroup;

  constructor(
    public modalCtrl: ModalController,
    private dataService: DataService,
    private analyticsService: AnalyticsService,
    private platform: Platform,
    private _toast: ToastController,
    public keycloak: KeycloakService,
    private loadingController: LoadingController,
    private _brukerService: BrukerService
  ) {}

  ngOnInit() {
    this.shareGroup = new FormGroup({
      epost: new FormControl(
        '',
        Validators.compose([Validators.email, Validators.required])
      )
    });
  }

  ionViewDidEnter() {
    this.keycloak
      .getKeycloakInstance()
      .loadUserInfo()
      .then((userInfo: KeycloakUserInfo) => {
        this.kundeIdFromKC = userInfo.kunde_id;
      });
    this._brukerService.getBrukerkunde().subscribe({
      next: (x) => {
        this.brukerkundeResponse = x.kundenumre;
        this.inUse = x.inUse;
        this.tildelte = x.tildelteTilganger;
      },
      error: (err) => {
        // console.log(err);
        // TODO: håndtere noe her?
      }
    });
  }

  async changeKunde(kundeid) {
    if (kundeid == this.kundeIdFromKC) return;

    const loading = await this.loadingController.create({
      message: 'Vennligst vent...',
      mode: this.platform.is('android') ? 'md' : 'ios'
    });
    await loading.present();

    this.brukerkundeResponse.forEach((element) => {
      if (element.kunde_id == kundeid) {
        //Post ny kunde,

        // Tror denne har litt lagg på å gi oppdatert respons?
        this._brukerService.putBrukerkunde(kundeid).subscribe({
          next: (res: BrukerkundeResponse) => {
            this.kundeIdFromKC = kundeid;
            this.inUse = element;
            this.analyticsService.logEvent_selectContent(
              'brukerkunde bytte kundeforhold'
            );
            //this.setInDataStore = true;
            this.keycloak.updateToken(-1).then((fulfilled) => {
              if (fulfilled) {
                this.dataService.setByttetKunde(kundeid);
                loading.dismiss();
                this.modalCtrl.dismiss({
                  changedActiveBruker: true
                });
              }
            });
          },
          error: (err) => {
            loading.dismiss();
            this.modalCtrl.dismiss();
          }
        });
      }
    });
  }

  async share() {
    if (this.inUse.tildelt) {
      // Kan ikke dele
      return;
    }

    const loading = await this.loadingController.create({
      message: 'Vennligst vent...',
      mode: this.platform.is('android') ? 'md' : 'ios'
    });
    await loading.present();

    this._brukerService
      .postBrukerkunde(this.shareGroup.get('epost').value)
      .subscribe({
        next: (res) => {
          if (res.ok) {
            this.analyticsService.logEvent_selectContent('brukerkunde share');
            this.shareGroup.setValue({ epost: '' });
            loading.dismiss();
            this.ionViewDidEnter();
          } else {
            this.analyticsService.logEvent_selectContent(
              'brukerkunde share feilet'
            );
            this.shareGroup.setValue({ epost: '' });
            loading.dismiss();
            this._toast
              .create({
                message: res.message,
                duration: 4000,
                position: 'middle',
                color: 'warning'
              })
              .then((toast) => {
                toast.present();
              });
          }
        },
        error: (err) => {
          // TODO: håndtere noe her?
        }
      });
  }

  async unshare(userId: string) {
    const loading = await this.loadingController.create({
      message: 'Vennligst vent...',
      mode: this.platform.is('android') ? 'md' : 'ios'
    });
    await loading.present();

    this._brukerService.deleteBrukerkunde(userId).subscribe({
      next: (x) => {
        this.analyticsService.logEvent_selectContent('brukerkunde unshare');
        loading.dismiss();
        this.ionViewDidEnter();
      },
      error: (err) => {
        // TODO: håndtere noe her?
        loading.dismiss();
      }
    });
  }

  public closeThisModal() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }
}
